import { MembershipSchema, SessionSchema, UserSchema } from '@cmoh/shared'
import { z } from 'zod'

/**
 * Validation schemas for better-auth responses
 */

export const AuthClientSessionDataSchema = z.object({
  user: UserSchema.nullable(),
  session: SessionSchema.nullable(),
})

export const AuthClientMembershipDataSchema = MembershipSchema.extend({
  userId: z.uuid(),
  user: UserSchema.partial().nullable().optional(),
  organization: z.object({ id: z.string(), name: z.string() }).nullable().optional(),
})

export const AuthClientSessionResponseSchema = z.object({
  data: AuthClientSessionDataSchema.nullable(),
})

export const AuthClientMembershipResponseSchema = z.object({
  data: AuthClientMembershipDataSchema.nullable(),
  error: z.any().nullable().optional(),
})

export const AuthClientCheckSlugDataSchema = z.object({
  status: z.boolean(),
})

export const AuthClientCheckSlugResponseSchema = z.object({
  data: AuthClientCheckSlugDataSchema.nullable(),
  error: z.any().nullable().optional(),
})

/**
 * Type definitions
 */

export type AuthClientSessionData = z.infer<typeof AuthClientSessionDataSchema>
export type AuthClientMembershipData = z.infer<typeof AuthClientMembershipDataSchema>
export type AuthClientSessionResponse = z.infer<typeof AuthClientSessionResponseSchema>
export type AuthClientMembershipResponse = z.infer<typeof AuthClientMembershipResponseSchema>
export type AuthClientCheckSlugData = z.infer<typeof AuthClientCheckSlugDataSchema>
export type AuthClientCheckSlugResponse = z.infer<typeof AuthClientCheckSlugResponseSchema>
